module.exports = __webpack_public_path__ + "img/top_shadow.22522b05.png";